import { ChevronDownLegacy } from '@wfp/icons-react';
import { Button, ContextMenu, Loading } from '@wfp/react';
import React, { FC, useState } from 'react';

import { API_HOST } from 'src/constants';
import { apiCallAsync } from 'src/redux/api/saga';
import { showNotification } from 'src/utils';
import ContextualMenu from './ContextualMenu';
import NotificationMessage from './NotificationMessage';

interface Props {
  period: string;
  projectCode: string;
  sectionId?: number;
}

interface ExportDocRequestPayload {
  comments_only: boolean;
  narratives_only: boolean;
  section_id?: number;
}

const IssuesDownloadDocButton: FC<Props> = ({
  period,
  projectCode,
  sectionId,
}) => {
  const [loadingFile, setLoadingFile] = useState(false);

  function exportContent(commentsOnly: boolean, narrativesOnly: boolean) {
    if (!period || !projectCode) return;

    const exportUrl =
      API_HOST + `/acr-api/issues-overview/${period}-${projectCode}/`;
    const data: ExportDocRequestPayload = {
      comments_only: commentsOnly,
      narratives_only: narrativesOnly,
    };
    if (sectionId) {
      data.section_id = sectionId;
    }
    let gaParam = 'narratives_and_comments';
    if (commentsOnly) {
      gaParam = 'comments';
    } else if (narrativesOnly) {
      gaParam = 'narratives';
    }

    setLoadingFile(true);
    apiCallAsync(exportUrl, data, 'post')
      .then(result => {
        if (result.status === 200) {
          showNotification(
            <NotificationMessage link={result.data.link} gaParam={gaParam} />,
            'success',
            {
              autoClose: false,
              closeOnClick: false,
            },
          );
        }
        setLoadingFile(false);
      })
      .catch(error => {
        console.log('error', error);
        setLoadingFile(false);
        showNotification('Error on .docx export', 'error');
      });
    return;
  }

  return (
    <>
      {loadingFile ? (
        <div className="issues-overview-page-download-btn">
          <Button
            className="loading-tables-generation"
            kind="secondary"
            disabled
          >
            <Loading
              className="wfp--loading--small"
              withOverlay={false}
              active
            />
            <div>Preparing .docx</div>
          </Button>
        </div>
      ) : (
        <ContextMenu
          className="io-context-menu-wrapper"
          content={<ContextualMenu exportContent={exportContent} />}
        >
          <span>
            <span className="wfp--btn wfp--btn--secondary noselect issue-download-docx-btn">
              Download as .docx
              <ChevronDownLegacy description="down-arrow" />
            </span>
          </span>
        </ContextMenu>
      )}
    </>
  );
};

export default IssuesDownloadDocButton;
